<template>
  <div
    class="flex items-center space-x-2 w-full border-0"
  >
    <input
      :id="elementId"
      :checked="modelValue === value"
      type="radio"
      :name="name"
      :value="value"
      class="h-4 w-4 rounded-full border-gray-300 text-primary-600 shadow-sm focus:border-blue-300 focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 focus:ring-offset-0 disabled:cursor-not-allowed disabled:text-gray-400"
      @input="$emit('update:modelValue', value)"
    >
    <slot>
      <label
        v-if="label"
        :for="elementId"
        class="text-sm flex-1 text-gray-600 cursor-pointer disabled:cursor-not-allowed truncate border-0 rounded-none"
      >
        {{ label }}
      </label>
    </slot>
  </div>
</template>
<script setup>
import { useProp } from '@/composables/useProp.js'
import { id } from 'random-html-id'
import { computed } from 'vue'

const elementId = computed(() => 'stormy-radio-' + id(8))

defineEmits(['update:modelValue'])
const props = defineProps({
  cols: useProp(Number, 3),
  checked: useProp([Array, Boolean], false),
  modelValue: useProp([String, Number, Boolean], false),
  horizontal: useProp(Boolean),
  name: useProp(String),
  label: useProp(String),
  value: useProp([String, Number, Boolean], false),
  required: useProp(Boolean),
  options: useProp(Array),
  vertical: useProp(Boolean)
})

const optionClasses = computed(() => `w-full grid grid-cols-${props.cols}`)

</script>
